import React, { useState, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useToasts } from 'react-toast-notifications';

import {
  saveAccessToken,
  saveRefreshToken,
  shouldPreserveTokens,
} from '../../../Redux/Tokens';
import LoginAnim from './Login.glitch';
import LoginDisplay from './Login.display';
import callLoginApi from './Login.actions';

const LOADED_FLAG = 'spaceforceiscoolbecauseitshowsamorematurestevecarell';

const connector = connect(undefined, {
  _saveAccessToken: saveAccessToken,
  _saveRefreshToken: saveRefreshToken,
  _shouldPreserveTokens: shouldPreserveTokens,
});

type ReduxProps = ConnectedProps<typeof connector>;

function Login({
  _saveAccessToken,
  _saveRefreshToken,
  _shouldPreserveTokens,
}: ReduxProps): React.ReactElement {
  const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();

  const showAnim = sessionStorage.getItem(LOADED_FLAG) ? false : true;

  async function onLogin(data: Record<string, unknown>) {
    const { preserveToken } = data;
    setLoading(true);
    try {
      const [accessToken, refreshToken] = await callLoginApi(data);
      _shouldPreserveTokens(preserveToken as string);
      _saveAccessToken(accessToken);
      _saveRefreshToken(refreshToken);
    } catch (error) {
      addToast(error.message, { appearance: 'error', autoDismiss: true });
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!sessionStorage.getItem(LOADED_FLAG)) {
      sessionStorage.setItem(LOADED_FLAG, 'true');
    }
  }, []);

  if (showAnim) {
    return <LoginAnim loading={loading} onLogin={onLogin} />;
  }

  return <LoginDisplay loading={loading} onLogin={onLogin} />;
}

export default connector(Login);
